import { resolve, ImResponse, storeHomeNVClient, leyanbotClient } from '.';

export interface ListParams {
  page: number;
  limit: number;
  type: Notice.FilterType;
}

export function list(params: ListParams) {
  return resolve(storeHomeNVClient.get<ImResponse<Notice.Item[]>>('/notice/list', { params }));
}

export function read(id: Notice.Item['id']) {
  return storeHomeNVClient.post('/notice/read', { id });
}

export function popupList() {
  return resolve(storeHomeNVClient.get<ImResponse<Notice.Item[]>>('/notice/popup'));
}

interface GetAppVersionInfoParams {
  appId: string;
  version: string;
}

interface GetAppVersionInfoData {
  appId: string;
  id: number;
  version: string;
  versionDescMap: {
    [k: string]: {
      content: string;
      title: string;
    };
  };
}

// 获取版本日志信息
export function getAppVersionInfo(params: GetAppVersionInfoParams) {
  return resolve(
    storeHomeNVClient.get<ImResponse<GetAppVersionInfoData>>('/app/version/info', { params }),
  );
}

// 获取通知未读数
export function getNoticeUnreadCount() {
  return resolve(storeHomeNVClient.get<ImResponse<number>>('/notice/unread_count'));
}

export function stats(id: number) {
  return leyanbotClient.post('/overseaim-store-home/stats', {
    id,
    source: 'NOTICE_USE_IMMEDIATELY',
    type: 0,
  });
}

export function statsSource(data: { id: number; type: number; source: string }) {
  return leyanbotClient.post('/overseaim-store-home/stats', data);
}
